export enum UserPermissions {
    Packaging_ReviewProposal_Read,
    Packaging_ReviewProposal_Write,
    Packaging_HotRequests_Read,
    Packaging_HotRequests_Write,
    Packaging_CreateProposal_Read,
    Packaging_CreateProposal_Write,
    Packaging_PackageTemplates_Read,
    Packaging_PackageTemplates_Write,
    Packaging_SearchPart_Read,
    Packaging_SearchPart_Write,
    Packaging_PackageEngineerAssignment_Read,
    Packaging_PackageEngineerAssignment_Write,
    Packaging_SourceType_Read,
    Packaging_SourceType_Write,
}
